// extracted by mini-css-extract-plugin
export var actionButton = "_fy-t";
export var buttonContainer = "_fy-0";
export var buttonContainer2 = "_fy-1";
export var buttonSection = "_fy-2";
export var details = "_fy-3";
export var dropdownItem = "_fy-5";
export var dropdownItemsContainer = "_fy-4";
export var fileInput = "_fy-r";
export var headerButton = "_fy-6";
export var icon = "_fy-7";
export var input = "_fy-8";
export var macroListItem = "_fy-9";
export var mainContent = "_fy-a";
export var microText = "_fy-b";
export var modal = "_fy-w";
export var optionsButton = "_fy-c";
export var paperclip = "_fy-s";
export var pillContent = "_fy-d";
export var preview = "_fy-e";
export var preview2 = "_fy-f";
export var quillEditor = "_fy-q";
export var selectedMacro = "_fy-g";
export var sidebar = "_fy-h";
export var sidebarHeader = "_fy-j";
export var sidebarList = "_fy-i";
export var sidebarListItem = "_fy-k";
export var sidebarSearch = "_fy-l";
export var snoozeDurationWrapper = "_fy-v";
export var statusPillContainer = "_fy-m";
export var tagsContainer = "_fy-n";
export var unselectedMacro = "_fy-o";
export var variable = "_fy-u";
export var wrapper = "_fy-p";